module.exports = __webpack_public_path__ + "static/img/stackable-conveyor-pole_256.3a934e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stackable-conveyor-pole_256.png
// module id = RFD6
// module chunks = 0